<template>
  <!-- Testimonials Section -->
  <section>
    <div class="_margin-top:2 _margin-bottom:4">
      <i-container>
        <i-row center>
          <i-column>
            <h2 class="_color:primary _text:left _text:4xl _text:bold _margin:0">
              The Proof Is in the Practice
            </h2>
            <p
              class="_text:left _text:lg _text:normal _text:dark-35 _margin-bottom:2 _margin-top:1/4">
              Frameworks that work. Straight from the professionals putting them to use.
            </p>
          </i-column>
        </i-row>
        <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-3 xl:grid-cols-3 gap-8">
          <div
            class="p-8 rounded-sm bg-[#f8f9fa] border-2 border-[#DDE2E4] my-2 sm:my-2 _display:flex _flex-direction:column _height:100%"
            data-aos="slide-up"
            data-aos-duration="500"
            data-aos-once="true">
            <div class="_display:flex _flex-direction:column _height:100%">
              <div class="_margin-bottom:1">
                <svg class="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                </svg>
              </div>
              <p class="_flex:1 text-lg _text:normal _text:dark-30 _padding-bottom:1 italic">
                "I've completed the course modules and found them comprehensive and well-structured.
                The content was relevant and impactful enough that I provided detailed feedback on
                each module through our local partner. The experience was professional and engaging
                throughout."
              </p>
              <div class="border-t border-gray-200 pt-4 _margin-top:auto">
                <div class="flex items-center space-x-3">
                  <img
                    src="/images/avatars/alexandra_f_avatar.jpg"
                    class="testimonial-avatar"
                    alt="Alexandra F.'s avatar" />
                  <div>
                    <h4 class="_text:dark-50 text-xl font-semibold _padding:0 _margin:0">
                      Alexandra F.
                    </h4>
                    <p class="text-sm _text:normal _text:dark-35 _padding-top:1/4">
                      Green Finance Professional
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="p-8 rounded-sm bg-[#f8f9fa] border-2 border-[#DDE2E4] my-2 sm:my-2 _display:flex _flex-direction:column _height:100%"
            data-aos="slide-up"
            data-aos-duration="600"
            data-aos-once="true">
            <div class="_display:flex _flex-direction:column _height:100%">
              <div class="_margin-bottom:1">
                <svg class="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                </svg>
              </div>
              <p class="_flex:1 text-lg _text:normal _text:dark-30 _padding-bottom:1 italic">
                "I'm truly happy to have the opportunity to take this course. Everything is working
                perfectly so far - no issues or bugs on my end. Even though I've just started, I can
                already tell this is going to be incredibly valuable. Thank you so much for creating
                such a great initiative!"
              </p>
              <div class="border-t border-gray-200 pt-4 _margin-top:auto">
                <div class="flex items-center space-x-3">
                  <img
                    src="/images/avatars/victoria_p_avatar.jpg"
                    class="testimonial-avatar"
                    alt="Victoria P.'s avatar" />
                  <div>
                    <h4 class="_text:dark-50 text-xl font-semibold _padding:0 _margin:0">
                      Victoria P.
                    </h4>
                    <p class="text-sm _text:normal _text:dark-35 _padding-top:1/4">
                      Renewable Energy Professional
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="p-8 rounded-sm bg-[#f8f9fa] border-2 border-[#DDE2E4] my-2 sm:my-2 _display:flex _flex-direction:column _height:100%"
            data-aos="slide-up"
            data-aos-duration="700"
            data-aos-once="true">
            <div class="_display:flex _flex-direction:column _height:100%">
              <div class="_margin-bottom:1">
                <svg class="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 24 24">
                  <path
                    d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h4v10h-10z" />
                </svg>
              </div>
              <p class="_flex:1 text-lg _text:normal _text:dark-30 _padding-bottom:1 italic">
                "The course's structure and flow are great. I'm impressed with how the platform
                handles complex supply chain risk management materials. I'm excited to continue
                developing additional courses here."
              </p>
              <div class="border-t border-gray-200 pt-4 _margin-top:auto">
                <div class="flex items-center space-x-3">
                  <img
                    src="/images/avatars/pierre_c_avatar.jpg"
                    class="testimonial-avatar"
                    alt="Pierre C.'s avatar" />
                  <div>
                    <h4 class="_text:dark-50 text-xl font-semibold _padding:0 _margin:0">
                      Pierre C.
                    </h4>
                    <p class="text-sm _text:normal _text:dark-35 _padding-top:1/4">
                      Supply Chain Expert
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </i-container>
    </div>
  </section>
</template>

<style scoped>
  .testimonial-avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    object-fit: cover;
    border: 1px solid rgb(228, 231, 237);
    flex-shrink: 0;
  }
</style>
